import { Icons } from "assets";
import classNames from "classnames";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactSlider from "react-slider";
import {
  GetOptionsListService,
  GetUsersListService,
} from "shared/services/general";
import { COLUMNS, JobRole, modifiers } from "shared/utils/enum";
import CustomButton from "../common/customButton";
import CustomDate from "../common/customDate";
import CustomInput from "../common/customInput";
import CustomRadioButton from "../common/customRadioButton";
import CustomSelect from "../common/customSelect";
import GlobalWrapper from "../common/globalWrapper";
import styles from "./style.module.scss";

interface SideCanvasProps {
  isShowColumns?: boolean;
  isOpen: boolean;
  selectedColumns: string[];
  setIsOpen: (val: boolean) => void;
  setSelectedColumns: (val: string[]) => void;
  routePath: string;
  parentFilters: any;
}

const initialValues = {
  startDate: "",
  endDate: "",
  status: "",
  user: "",
  jobTitle: "",
  department: "",
  jobCode: "",
  jobGrade: "",
  roleType: null,
  modifier: "",
  levelOfWork: "",
  q2: "",
  q3: "",
  q4: "",
  q5: "",
  q6: "",
  q7: "",
  q8: "",
  minScore: 40,
  maxScore: 2200,
  minLvl: 1,
  maxLvl: 31,
};

const FilterSideCanvas = ({
  isShowColumns = true,
  isOpen,
  selectedColumns,
  routePath,
  parentFilters,
  setIsOpen,
  setSelectedColumns,
}: SideCanvasProps) => {
  const navigate = useNavigate();
  const allOptions = useRef<any[]>([]);
  const filtersRef = useRef<any>({
    ...initialValues,
  });
  const usersRef = useRef<any[]>([]);
  const lvlofWorkOptionsRef = useRef<any[]>([]);
  const q2OptionsRef = useRef<any[]>([]);
  const q3OptionsRef = useRef<any[]>([]);
  const q4OptionsRef = useRef<any[]>([]);
  const q5OptionsRef = useRef<any[]>([]);
  const q6OptionsRef = useRef<any[]>([]);
  const q7OptionsRef = useRef<any[]>([]);
  const q8OptionsRef = useRef<any[]>([]);
  const [showColumns, setShowColumns] = useState<boolean>(true);
  const [coloumns, setColumns] = useState<string[]>([...selectedColumns]);
  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [lvlofWorkOptions, setLvlofWorkOptions] = useState<any[]>([]);
  const [q2Options, setQ2Options] = useState<any[]>([]);
  const [q3Options, setQ3Options] = useState<any[]>([]);
  const [q4Options, setQ4Options] = useState<any[]>([]);
  const [q5Options, setQ5Options] = useState<any[]>([]);
  const [q6Options, setQ6Options] = useState<any[]>([]);
  const [q7Options, setQ7Options] = useState<any[]>([]);
  const [q8Options, setQ8Options] = useState<any[]>([]);
  const [filters, setFilters] = useState<any>({
    ...initialValues,
  });

  const statusOptions = [
    {
      title: "Active",
      Icon: null,
      action: () => {
        setFieldValue("status", {
          title: "Active",
          value: 1,
        });
      },
    },
    {
      title: "Inactive",
      Icon: null,
      action: () => {
        setFieldValue("status", {
          title: "Inactive",
          value: 0,
        });
      },
    },
  ];

  const roleTypeOptions = [
    {
      title: "Management",
      Icon: null,
      action: () => {
        setFieldValue("roleType", {
          title: "Management",
          value: JobRole.management,
        });
        handlePopulateOptions(JobRole.management);
        setFieldValue("modifier", "");
        setFieldValue("levelOfWork", "");
        setFieldValue("q2", "");
        setFieldValue("q3", "");
        setFieldValue("q4", "");
        setFieldValue("q5", "");
        setFieldValue("q6", "");
        setFieldValue("q7", "");
        setFieldValue("q8", "");
      },
    },
    {
      title: "Individual Contributor",
      Icon: null,
      action: () => {
        setFieldValue("roleType", {
          title: "Individual Contributor",
          value: JobRole.individualContributor,
        });
        handlePopulateOptions(JobRole.individualContributor);
        setFieldValue("modifier", "");
        setFieldValue("levelOfWork", "");
        setFieldValue("q2", "");
        setFieldValue("q3", "");
        setFieldValue("q4", "");
        setFieldValue("q5", "");
        setFieldValue("q6", "");
        setFieldValue("q7", "");
        setFieldValue("q8", "");
      },
    },
  ];

  const modifierOptions = [
    {
      title: modifiers.plus,
      Icon: null,
      action: () => {
        setFieldValue("modifier", {
          title: modifiers.plus,
          value: modifiers.plus,
        });
      },
    },
    {
      title: modifiers.equal,
      Icon: null,
      action: () => {
        setFieldValue("modifier", {
          title: modifiers.equal,
          value: modifiers.equal,
        });
      },
    },
    {
      title: modifiers.minus,
      Icon: null,
      action: () => {
        setFieldValue("modifier", {
          title: modifiers.minus,
          value: modifiers.minus,
        });
      },
    },
  ];

  const setFieldValue = (field: string, value: any) => {
    let tempObj = { ...filtersRef.current };
    tempObj[field] = value;
    filtersRef.current = tempObj;
    setFilters(filtersRef.current);
  };

  function handleClick(e: any) {
    const elem: any = document.getElementById("filterSideCanvas");
    if (!elem.contains(e.target)) {
      setIsOpen(false);
    }
  }

  const handleGetUsersList = () => {
    GetUsersListService()
      .then(({ data }) => {
        usersRef.current = data;
        let tempArr = [];
        for (let i = 0; i < data.length; i++) {
          let obj = {
            title: data[i].name,
            Icon: null,
            action: () => {
              setFieldValue("user", {
                title: data[i].name,
                value: data[i].id,
              });
            },
          };
          tempArr.push(obj);
        }
        setUserOptions(tempArr);
      })
      .catch((err) => {});
  };

  const handleOptionsInitialSetup = (key: any, arr: any) => {
    let tempArr = [];
    for (let i = 0; i < arr?.length; i++) {
      let job = arr[i];
      let obj = {
        title: job?.short_des,
        Icon: null,
        action: () => {
          setFieldValue(key, {
            title: job?.short_des,
            value: job?.id,
          });
        },
      };
      tempArr.push(obj);
    }
    return tempArr;
  };

  const handlePopulateOptions = (role: string) => {
    let data = allOptions.current;
    let tempLvlOptions: any[] = [];
    let tempq2Options: any[] = [];
    let tempq3Options: any[] = [];
    let tempq4Options: any[] = [];
    let tempq5Options: any[] = [];
    let tempq6Options: any[] = [];
    let tempq7Options: any[] = [];
    let tempq8Options: any[] = [];
    if (role === JobRole.individualContributor) {
      tempLvlOptions = data?.[0]?.options_1;
      tempq2Options = data?.[1]?.options_1;
      tempq3Options = data?.[2]?.options_1;
      tempq4Options = data?.[3]?.options_1;
      tempq5Options = data?.[4]?.options_1;
      tempq6Options = data?.[5]?.options_1;
      tempq7Options = data?.[6]?.options_1;
      tempq8Options = data?.[7]?.options_1;
    } else if (role === JobRole.management) {
      tempLvlOptions = data?.[0]?.options_2;
      tempq2Options = data?.[1]?.options_2;
      tempq3Options = data?.[2]?.options_2;
      tempq4Options = data?.[3]?.options_2;
      tempq5Options = data?.[4]?.options_2;
      tempq6Options = data?.[5]?.options_2;
      tempq7Options = data?.[6]?.options_2;
      tempq8Options = data?.[7]?.options_2;
    }
    lvlofWorkOptionsRef.current = tempLvlOptions;
    let tempArr = handleOptionsInitialSetup("levelOfWork", tempLvlOptions);
    setLvlofWorkOptions(tempArr);
    q2OptionsRef.current = tempq2Options;
    tempArr = handleOptionsInitialSetup("q2", tempq2Options);
    setQ2Options(tempArr);
    q3OptionsRef.current = tempq3Options;
    tempArr = handleOptionsInitialSetup("q3", tempq3Options);
    setQ3Options(tempArr);
    q4OptionsRef.current = tempq4Options;
    tempArr = handleOptionsInitialSetup("q4", tempq4Options);
    setQ4Options(tempArr);
    q5OptionsRef.current = tempq5Options;
    tempArr = handleOptionsInitialSetup("q5", tempq5Options);
    setQ5Options(tempArr);
    q6OptionsRef.current = tempq6Options;
    tempArr = handleOptionsInitialSetup("q6", tempq6Options);
    setQ6Options(tempArr);
    q7OptionsRef.current = tempq7Options;
    tempArr = handleOptionsInitialSetup("q7", tempq7Options);
    setQ7Options(tempArr);
    q8OptionsRef.current = tempq8Options;
    tempArr = handleOptionsInitialSetup("q8", tempq8Options);
    setQ8Options(tempArr);
  };

  const handleGetOptionsList = () => {
    GetOptionsListService()
      .then(({ data }) => {
        allOptions.current = data;
        handlePopulateOptions(JobRole.individualContributor);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handleGetUsersList();
    handleGetOptionsList();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let elem: any = document.getElementById("filterBackDropContainer");
    if (elem) {
      elem.addEventListener("click", (event: any) => {
        handleClick(event);
      });
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      filtersRef.current.startDate === "" ||
      filtersRef.current.endDate === ""
    ) {
      let dayElems: HTMLCollectionOf<Element> = document.getElementsByClassName(
        "react-date-picker__inputGroup__day"
      );
      let monthsElems: HTMLCollectionOf<Element> =
        document.getElementsByClassName("react-date-picker__inputGroup__month");
      let yearsElems: HTMLCollectionOf<Element> =
        document.getElementsByClassName(
          "react-date-react-date-picker__inputGroup__year"
        );
      for (let i = 0; i < dayElems.length; i++) {
        let singleDayElem = dayElems[i];
        //@ts-ignore
        singleDayElem.style.width = "17px";
      }
      for (let i = 0; i < monthsElems.length; i++) {
        let singleMonthElem = monthsElems[i];
        //@ts-ignore
        singleMonthElem.style.width = "23px";
      }
      for (let i = 0; i < yearsElems.length; i++) {
        let singleYearElem = yearsElems[i];
        //@ts-ignore
        singleYearElem.style.width = "30px";
      }
    }
  }, []);

  useEffect(() => {
    if (parentFilters?.status !== null) {
      if (parentFilters?.status === "0") {
        setFieldValue("status", {
          title: "Inactive",
          value: 0,
        });
      } else {
        setFieldValue("status", {
          title: "Active",
          value: 1,
        });
      }
    } else {
      setFieldValue("status", "");
    }

    if (parentFilters?.roleType !== null) {
      if (parentFilters?.roleType === JobRole.individualContributor) {
        setFieldValue("roleType", {
          title: "Individual Contributor",
          value: JobRole.individualContributor,
        });
        if (allOptions.current.length > 0) {
          handlePopulateOptions(JobRole.individualContributor);
        }
      } else {
        setFieldValue("roleType", {
          title: "Management",
          value: JobRole.management,
        });
        if (allOptions.current.length > 0) {
          handlePopulateOptions(JobRole.management);
        }
      }
    } else {
      setFieldValue("roleType", null);
    }

    if (parentFilters?.startDate !== null) {
      setFieldValue("startDate", parentFilters?.startDate);
    } else {
      setFieldValue("startDate", "");
    }

    if (parentFilters?.endDate !== null) {
      setFieldValue("endDate", parentFilters?.endDate);
    } else {
      setFieldValue("endDate", "");
    }

    if (parentFilters?.user !== null) {
      let foundUser = usersRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.user)
      )[0];
      setFieldValue("user", {
        title: foundUser?.name,
        value: foundUser?.id,
      });
    } else {
      setFieldValue("user", "");
    }

    if (parentFilters?.jobTitle !== null) {
      setFieldValue("jobTitle", parentFilters?.jobTitle);
    } else {
      setFieldValue("jobTitle", "");
    }

    if (parentFilters?.department !== null) {
      setFieldValue("department", parentFilters?.department);
    } else {
      setFieldValue("department", "");
    }

    if (parentFilters?.jobCode !== null) {
      setFieldValue("jobCode", parentFilters?.jobCode);
    } else {
      setFieldValue("jobCode", "");
    }

    if (parentFilters?.jobGrade !== null) {
      setFieldValue("jobGrade", parentFilters?.jobGrade);
    } else {
      setFieldValue("jobGrade", "");
    }

    if (parentFilters?.modifier !== null) {
      if (parentFilters?.modifier === modifiers.plus) {
        setFieldValue("modifier", {
          title: modifiers.plus,
          value: modifiers.plus,
        });
      } else if (parentFilters?.modifier === modifiers.equal) {
        setFieldValue("modifier", {
          title: modifiers.equal,
          value: modifiers.equal,
        });
      } else if (parentFilters?.modifier === modifiers.minus) {
        setFieldValue("modifier", {
          title: modifiers.minus,
          value: modifiers.minus,
        });
      }
    } else {
      setFieldValue("modifier", "");
    }

    if (parentFilters?.minScore !== null) {
      setFieldValue("minScore", Number(parentFilters?.minScore));
    } else {
      setFieldValue("minScore", 40);
    }

    if (parentFilters?.maxScore !== null) {
      setFieldValue("maxScore", Number(parentFilters?.maxScore));
    } else {
      setFieldValue("maxScore", 2200);
    }

    if (parentFilters?.minLvl !== null) {
      setFieldValue("minLvl", Number(parentFilters?.minLvl));
    } else {
      setFieldValue("minLvl", 1);
    }

    if (parentFilters?.maxLvl !== null) {
      setFieldValue("maxLvl", Number(parentFilters?.maxLvl));
    } else {
      setFieldValue("maxLvl", 31);
    }

    if (parentFilters?.levelOfWork !== null) {
      let foundOption = lvlofWorkOptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.levelOfWork)
      )[0];
      setFieldValue("levelOfWork", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("levelOfWork", "");
    }

    if (parentFilters?.q2 !== null) {
      let foundOption = q2OptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.q2)
      )[0];
      setFieldValue("q2", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("q2", "");
    }

    if (parentFilters?.q3 !== null) {
      let foundOption = q3OptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.q3)
      )[0];
      setFieldValue("q3", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("q3", "");
    }

    if (parentFilters?.q4 !== null) {
      let foundOption = q4OptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.q4)
      )[0];
      setFieldValue("q4", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("q4", "");
    }

    if (parentFilters?.q5 !== null) {
      let foundOption = q5OptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.q5)
      )[0];
      setFieldValue("q5", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("q5", "");
    }

    if (parentFilters?.q6 !== null) {
      let foundOption = q6OptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.q6)
      )[0];
      setFieldValue("q6", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("q6", "");
    }

    if (parentFilters?.q7 !== null) {
      let foundOption = q7OptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.q7)
      )[0];
      setFieldValue("q7", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("q7", "");
    }

    if (parentFilters?.q8 !== null) {
      let foundOption = q8OptionsRef?.current?.filter(
        (itm) => itm?.id === Number(parentFilters?.q8)
      )[0];
      setFieldValue("q8", {
        title: foundOption?.short_des,
        value: foundOption?.id,
      });
    } else {
      setFieldValue("q8", "");
    }

    // eslint-disable-next-line
  }, [parentFilters, allOptions.current, userOptions]);

  return (
    <GlobalWrapper>
      <aside
        className={classNames(styles.backDropContainer)}
        style={isOpen ? { visibility: "visible" } : { visibility: "hidden" }}
        id="filterBackDropContainer"
      >
        <div
          className={classNames(
            styles.mainContainer,
            isOpen ? styles.shown : styles.hidden,
            "py-5"
          )}
          id="filterSideCanvas"
        >
          <div
            className={classNames(
              "flex justify-between items-center px-5 gap-4"
            )}
          >
            <h1 className={classNames(styles.title)}>Filters</h1>

            <Icons.ArrowRightOutline
              className={classNames(styles.backIcon)}
              onClick={() => {
                setIsOpen(false);
              }}
            />
          </div>
          <div
            className={classNames(
              "flex flex-col justify-between  px-5 gap-4 mt-6"
            )}
          >
            {isShowColumns ? (
              <div
                className={classNames(
                  "flex flex-col gap-3",
                  styles.columnsContainer
                )}
              >
                <div
                  className={classNames(styles.labelContainer, "pt-3")}
                  onClick={() => {
                    setShowColumns(!showColumns);
                  }}
                >
                  <label className={classNames(styles.label)}>
                    Show Columns
                  </label>
                  {showColumns ? <Icons.ChevUp /> : <Icons.ChevDown />}
                </div>
                <div
                  className={classNames(
                    styles.columnsListContainer,
                    showColumns && "mb-3"
                  )}
                  style={showColumns ? { height: "272px" } : { height: "0px" }}
                >
                  {COLUMNS.map((itm, inx) => {
                    return (
                      <RadioButton
                        key={inx}
                        label={itm}
                        selectedColumns={coloumns}
                        setSelectedColumns={setColumns}
                      />
                    );
                  })}
                </div>
              </div>
            ) : null}

            <div className={classNames("flex flex-col gap-3")}>
              <label className={classNames(styles.label)}>Date</label>
              <div className={classNames("flex items-center justify-between")}>
                <div className={classNames(styles.dateContainer, "relative")}>
                  <label>From</label>
                  <CustomDate
                    value={filters.startDate}
                    placeholder="yyyy-mm-dd"
                    onChange={(e) => {
                      setFieldValue(
                        "startDate",
                        moment(e.currentTarget.value).format("YYYY-MM-DD")
                      );
                    }}
                    max={filters.endDate}
                  />
                </div>
                <div className={classNames(styles.dash)} />
                <div className={classNames(styles.dateContainer)}>
                  <label>To</label>
                  <CustomDate
                    value={filters.endDate}
                    placeholder="yyyy-mm-dd"
                    min={filters.startDate}
                    onChange={(e) => {
                      setFieldValue(
                        "endDate",
                        moment(e.currentTarget.value).format("YYYY-MM-DD")
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <CustomSelect
              label="Status"
              placeholder="Select Status"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={statusOptions}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.status?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.status}
              clearSelection={() => {
                setFieldValue("status", "");
              }}
            />
            <CustomSelect
              label="Filter by User"
              placeholder="Select User"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={userOptions}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.user?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.user}
              clearSelection={() => {
                setFieldValue("user", "");
              }}
            />
            <CustomInput
              label="Job Title"
              placeholder="Enter"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              value={filters?.jobTitle}
              onChange={(e) => {
                setFieldValue("jobTitle", e.currentTarget.value);
              }}
              customInputStyle={classNames(styles.inputStyle)}
            />
            <CustomInput
              label="Department"
              placeholder="Enter"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              value={filters?.department}
              onChange={(e) => {
                setFieldValue("department", e.currentTarget.value);
              }}
              customInputStyle={classNames(styles.inputStyle)}
            />
            <CustomInput
              label="Job Code"
              placeholder="Enter"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              value={filters?.jobCode}
              onChange={(e) => {
                setFieldValue("jobCode", e.currentTarget.value);
              }}
              customInputStyle={classNames(styles.inputStyle)}
            />
            <CustomInput
              label="Job Grade"
              placeholder="Enter"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              value={filters?.jobGrade}
              onChange={(e) => {
                setFieldValue("jobGrade", e.currentTarget.value);
              }}
              customInputStyle={classNames(styles.inputStyle)}
            />
            <CustomSelect
              label="Role Type"
              placeholder="Select Role Type"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={roleTypeOptions}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.roleType?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.roleType}
              clearSelection={() => {
                setFieldValue("roleType", "");
              }}
            />
            <CustomSelect
              label="Modifier"
              placeholder="Select Modifier"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={modifierOptions}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.modifier?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.modifier}
              clearSelection={() => {
                setFieldValue("modifier", "");
              }}
            />
            <CustomSelect
              label="Level of Work"
              placeholder="Select Level of Work"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={lvlofWorkOptions}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.levelOfWork?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.levelOfWork}
              clearSelection={() => {
                setFieldValue("levelOfWork", "");
              }}
            />
            <CustomSelect
              label="Institutional Expertise & Skill"
              placeholder="Select Institutional Expertise & Skill"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={q2Options}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.q2?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.q2}
              clearSelection={() => {
                setFieldValue("q2", "");
              }}
            />
            <CustomSelect
              label="Cultural Impact"
              placeholder="Select Cultural Impact"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={q3Options}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.q3?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.q3}
              clearSelection={() => {
                setFieldValue("q3", "");
              }}
            />
            <CustomSelect
              label="Physical Environment"
              placeholder="Select Physical Environment"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={q4Options}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.q4?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.q4}
              clearSelection={() => {
                setFieldValue("q4", "");
              }}
            />
            <CustomSelect
              label="Mental & Emotional Environment"
              placeholder="Select Mental & Emotional Environment"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={q5Options}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.q5?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.q5}
              clearSelection={() => {
                setFieldValue("q5", "");
              }}
            />
            <CustomSelect
              label="Application of Knowledge & Skill"
              placeholder="Select Application of Knowledge & Skill"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={q6Options}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.q6?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.q6}
              clearSelection={() => {
                setFieldValue("q6", "");
              }}
            />
            <CustomSelect
              label="Manual Effort"
              placeholder="Select Manual Effort"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={q7Options}
              customOptionsContainer={classNames(styles.optionsContainer)}
              value={filters?.q7?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.q7}
              clearSelection={() => {
                setFieldValue("q7", "");
              }}
            />
            <CustomSelect
              label="Outcomes"
              placeholder="Outcomes"
              customLabelStyle={classNames(styles.label)}
              customInputContainer={classNames(styles.selectInputContainer)}
              options={q8Options}
              customOptionsContainer={classNames(styles.optionsContainer)}
              direction="bottom"
              value={filters?.q8?.title}
              wrapInGlobalWrapper={false}
              selectedOption={filters?.q8}
              clearSelection={() => {
                setFieldValue("q8", "");
              }}
            />
            <div className={classNames("flex flex-col gap-9")}>
              <label className={classNames(styles.label)}>RAS Score</label>
              <ReactSlider
                className={classNames(styles.slider)}
                min={40}
                max={2200}
                defaultValue={[40, 2200]}
                ariaLabel={["Lower thumb", "Upper thumb"]}
                ariaValuetext={(state: any) => `Thumb value ${state.valueNow}`}
                minDistance={200}
                pearling
                renderThumb={(props: any, state: any) => (
                  <div {...props} className={classNames(styles.thumb)}>
                    <label className={classNames(styles.value)}>
                      {state.valueNow}
                    </label>
                    <div className={classNames(styles.dot)} />
                  </div>
                )}
                trackClassName={"track2"}
                value={[filters?.minScore, filters?.maxScore]}
                onChange={(value: any) => {
                  setFieldValue("minScore", value[0]);
                  setFieldValue("maxScore", value[1]);
                }}
              />
            </div>
            <div className={classNames("flex flex-col gap-9 mt-4")}>
              <label className={classNames(styles.label)}>RAS Level</label>
              <ReactSlider
                className={classNames(styles.slider)}
                min={1}
                max={31}
                defaultValue={[1, 31]}
                ariaLabel={["Lower thumb", "Upper thumb"]}
                ariaValuetext={(state: any) => `Thumb value ${state.valueNow}`}
                minDistance={2}
                pearling
                renderThumb={(props: any, state: any) => (
                  <div {...props} className={classNames(styles.thumb)}>
                    <label className={classNames(styles.value)}>
                      {state.valueNow}
                    </label>
                    <div className={classNames(styles.dot)} />
                  </div>
                )}
                trackClassName={"track2"}
                value={[filters?.minLvl, filters?.maxLvl]}
                onChange={(value: any) => {
                  setFieldValue("minLvl", value[0]);
                  setFieldValue("maxLvl", value[1]);
                }}
              />
            </div>
            <div
              className={classNames(
                "flex items-center justify-between gap-3 mt-6"
              )}
            >
              <CustomButton
                title="Clear"
                containerStyle={classNames(styles.clearBtn)}
                onClick={() => {
                  filtersRef.current = {
                    ...initialValues,
                  };
                  setColumns([]);
                  setSelectedColumns([]);
                  setFilters(filtersRef.current);
                  setIsOpen(false);
                  navigate(routePath);
                }}
              />
              <CustomButton
                title="Apply"
                containerStyle={classNames(styles.applyBtn)}
                onClick={() => {
                  setSelectedColumns(coloumns);
                  let filtersObj = {
                    startDate: filtersRef.current.startDate,
                    endDate: filtersRef.current.endDate,
                    status: filtersRef.current.status?.value,
                    user: filtersRef.current.user?.value,
                    jobTitle: filtersRef.current.jobTitle,
                    department: filtersRef.current.department,
                    jobCode: filtersRef.current.jobCode,
                    jobGrade: filtersRef.current.jobGrade,
                    roleType: filtersRef.current.roleType?.value,
                    modifier: filtersRef.current.modifier?.value,
                    levelOfWork: filtersRef.current.levelOfWork?.value,
                    q2: filtersRef.current.q2?.value,
                    q3: filtersRef.current.q3?.value,
                    q4: filtersRef.current.q4?.value,
                    q5: filtersRef.current.q5?.value,
                    q6: filtersRef.current.q6?.value,
                    q7: filtersRef.current.q7?.value,
                    q8: filtersRef.current.q8?.value,
                    minScore: filtersRef.current.minScore,
                    maxScore: filtersRef.current.maxScore,
                    minLvl: filtersRef.current.minLvl,
                    maxLvl: filtersRef.current.maxLvl,
                  };
                  const query = new URLSearchParams({ ...filtersObj });
                  navigate(routePath + `?${query.toString()}`);
                  setIsOpen(false);
                }}
              />
            </div>
          </div>
        </div>
      </aside>
    </GlobalWrapper>
  );
};

interface RadioButtonProps {
  label: string;
  selectedColumns: string[];
  setSelectedColumns: (val: string[]) => void;
}

const RadioButton = ({
  label,
  selectedColumns,
  setSelectedColumns,
}: RadioButtonProps) => {
  const handleOnClick = () => {
    let tempArr = [...selectedColumns];
    if (!tempArr.includes(label)) {
      tempArr.push(label);
    } else {
      tempArr = tempArr.filter((itm) => itm !== label);
    }
    setSelectedColumns(tempArr);
  };
  return (
    <div
      className={classNames(styles.selectionContainer, "py-2 gap-2")}
      onClick={handleOnClick}
    >
      <CustomRadioButton
        active={selectedColumns.includes(label) ? true : false}
      />
      <label>{label}</label>
    </div>
  );
};

export default FilterSideCanvas;
